import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { alert_error, alert_success } from '../AppContext';
import { Cookies } from '../index.js';

const App = () => {
    const dispatch = useDispatch();
    const showauth = useSelector((state) => state.showauth);
    const [nutxuly, setNutxuly] = useState(0);
    const [phonenumber, setPhonenumber] = useState('');
    const [madangnhap, setMadangnhap] = useState('');
    const [isinputdisabled, setIsinputdisabled] = useState(false);
    const [chedo, setChedo] = useState('phonenumber');
    const [nutorder, setNutorder] = useState('');
    const [thanhcong, setThanhcong] = useState('');
    const [showadsmob, setShowadsmob] = useState('');

    useEffect(() => {
        const storedShowadsmob = localStorage.getItem('showadsmob');
        if (storedShowadsmob) {
            setShowadsmob(storedShowadsmob);
        } else {
            console.log('No showadsmob found.');
        }
    }, []);

    const dathang = (response) => {
        setNutorder('Confirming...');
        const { status, message, chedo: cheodo_api, apikey, redirect } = response.data;

        if (status == 0) {
            alert_error(message);
        } else if (status == 1) {
            alert_success(message);
        }
        if (message) {
            setThanhcong(message);
        }
        if (cheodo_api) {
            setIsinputdisabled(false);
            setChedo(cheodo_api);
        }
        if (apikey) {
            alert_success('Login successful');
            setTimeout(() => sussces(apikey), 400);
        }
        if (redirect != null && redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = response.data.redirect;
            }, 1700);
        }
    };

    const sussces = (apikey) => {
        const expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        Cookies.set('apikey', apikey, { expires: expirationDate });
        console.log('Login successful');
    };

    const signup = () => {
        setNutxuly(1);
        setNutorder('Please wait...');
        setIsinputdisabled(false);
        if (!chedo || !phonenumber) {
            setNutxuly(0);
            setNutorder('Confirm');
            alert_error('Please enter information');
        } else {
            axios
                .post('https://hust.media/api/auth/login_tele.php', {
                    chedo,
                    phonenumber,
                    madangnhap,
                })
                .then((response) => {
                    setNutxuly(0);
                    dathang(response);
                })
                .catch((error) => alert_error(error.message));
        }
    };

    return (
        <div className="p-4 mx-auto max-w-md">
            {showadsmob && (
                <div className="mb-4 flex justify-center">
                    <div className="h-16 w-full bg-gray-300 rounded-md">Ad Placeholder</div>
                </div>
            )}

            <div className="bg-gradient-to-r from-pink-500 to-purple-500 p-4 rounded-3xl shadow-lg">
                <div className="bg-white rounded-3xl p-4">
                    <h2 className="text-xl text-center mb-3">Login with Telegram</h2>

                    <div className="mb-2">
                        <label className="block text-lg font-medium mb-2">Phone Number:</label>
                        <input
                            type="text"
                            value={phonenumber}
                            onChange={(e) => setPhonenumber(e.target.value)}
                            disabled={isinputdisabled}
                            placeholder="Nhập số điện thoại của bạn..."
                            className="w-full border border-pink-400 rounded-sm p-2 focus:outline-none"
                        />
                    </div>

                    <div className="text-center text-xs text-gray-500 mb-2">
                        Bổ sung (Chỉ tài khoản đã liên kết telegram mới đăng nhập được kiểu này)
                    </div>

                    {chedo === 'signin' && (
                        <div className="mb-4">
                            <label className="block text-lg font-medium mb-2">Mã:</label>
                            <input
                                type="text"
                                value={madangnhap}
                                onChange={(e) => setMadangnhap(e.target.value)}
                                placeholder="Sao chép mã và điền vô đây"
                                className="w-full border border-pink-400 rounded-sm p-2 focus:outline-none"
                            />
                        </div>
                    )}

                    <button
                        onClick={signup}
                        disabled={nutxuly === 1}
                        className={`w-full py-2 rounded-3xl text-lg font-medium text-white ${nutxuly === 1 ? 'bg-gray-400' : 'bg-purple-400 hover:bg-purple-300'}`}
                    >
                        {nutxuly === 1 ? 'Loading...' : '✔️ Click to Confirm'}
                    </button>

                    {thanhcong && (
                        <div className="mt-3 p-2 bg-gray-100 rounded-2xl text-center">
                            <p className="text-black text-sm mb-2">Result:</p>
                            <p className="text-purple-400 text-lg font-bold">{thanhcong}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default App;